// extracted by mini-css-extract-plugin
export default {"button":"ScrollToEdgeButton_button__-azNa"};